export namespace MultibancosCamposObrigatorios {
	export const dadosOperacao = [
		'valorImovel',
		'valorFinanciado',
		'estado',
		'tipoImovel',
		'valorEntrada' //Tirei esse campo, pq é um campo calculado, entao quando o valorimovel/financiamento for preenchido, ele é preenchido junto
	]

	//Campos obrigatorios para proponentes em geral
	export const proponente = [
		'cpf',
		'nomeCliente',
		'dtNascimento',
		'estadoCivil',
		'email',
		'dsSexo',
		'nmMae',
		'dsNacionalidade',
		'tipoDocto',
		'nroDocto',
		'dsOrgaoExpedidorRg',
		'dataEmissaoDocto',
		'nrCep',
		'nmEndereco',
		'nrEndereco',
		'nmBairro',
		'nmCidade',
		'sglUf',
		'nrCelular',
		'dsNaturalidade',
	]

	export const dadosImovel = ['cep', 'endereco', 'numero', 'bairro', 'cidade', 'uf']

	export const profissao = ['dsNomeEmpresa', 'dsProfissao', 'dsCargo', 'dsTipoContratacao', 'dtAdmissao', 'vlRendaMensal']

	export const dadosVendedor = [
		'tipoVendedor',
		'nome',
		'cpfCnpj',
		'email',
		'estadoCivil',
		'telefone',
		'cep',
		'endereco',
		'numero',
		'bairro',
		'cidade',
		'uf',
		'profissao',
		'correntistaBradesco'
	]

	//Especificos (combinar com os gerais)
	export const proponentesSantanderCamposExtras = ['dsTipoResidencia', 'dsTempoResidencia']

	//Quando o proponente for casado, esses campos sao obrigatorios tambem
	export const proponenteCasadoCamposExtras = ['dsRegimeCasamentoUniao', 'dtCasamentoUniaoEstavel']
}
